import type { ExpenseTypeDefinition } from "@/api/types";
import { Icon } from "@/components/Icon";

/**
 * The message an expense type tells people (set under Categories & rules, "Tell them something"):
 * orange when set to Warn, red when set to Enforce, and not shown when Off. There's nothing to
 * answer, so it never holds a report up.
 */
export function TypeNotice({ type }: { type: ExpenseTypeDefinition | undefined }) {
  if (!type || type.field !== "Notice" || type.fieldRequired === "Off" || !type.fieldPrompt?.trim())
    return null;
  return (
    <div className={`note type-notice ${type.fieldRequired === "Block" ? "danger" : "warn"}`}>
      <Icon name="alert" size={16} />
      <span>{type.fieldPrompt}</span>
    </div>
  );
}
